import script from "./stocks.vue?vue&type=script&setup=true&lang=js"
export * from "./stocks.vue?vue&type=script&setup=true&lang=js"

import "./stocks.vue?vue&type=style&index=0&id=0c20b664&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c20b664"]])

export default __exports__